import { post } from './client';

export function runRx(growerId, params) {
  return post(`/growers/${growerId}/prescriptions`, params);
}
